/**
 * @file
 * The inline quick-create form.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const {
    el,
    button,
    icon,
    iconButton,
    textSpan,
    setHidden,
    isHidden,
    onClick,
  } = berTags.dom;
  const { announce } = berTags.util;

  // Quick-create block. onSubmit returns a promise, busy/error handled here.
  components.createForm = ({ label, onSubmit }) => {
    const wrap = el('div', 'ber-tags__create');

    const toggle = button('ber-tags__create-toggle');
    toggle.append(
      icon('add'),
      textSpan('ber-tags__create-toggle-label', label),
    );

    const form = el('div', 'ber-tags__create-form is-hidden');

    const input = el('input', 'ber-tags__create-input');
    input.type = 'text';
    input.placeholder = label;
    input.setAttribute('aria-label', label);
    input.maxLength = 255;

    const confirm = iconButton('ber-tags__create-add', Drupal.t('Add'), 'add');
    confirm.disabled = true;

    const cancel = iconButton(
      'ber-tags__create-cancel',
      Drupal.t('Cancel'),
      'close',
    );

    const error = el('div', 'ber-tags__create-error is-hidden');

    form.append(input, confirm, cancel);
    wrap.append(toggle, form, error);

    let pending = false;

    const showForm = (show) => {
      setHidden(form, !show);
      setHidden(toggle, show);
      setHidden(error, true);
      input.value = '';
      confirm.disabled = true;
      if (show) {
        input.focus();
      }
    };

    const collapse = () => {
      showForm(false);
      toggle.focus();
    };

    const submit = () => {
      const value = input.value.trim();
      if (value === '' || pending) {
        return;
      }
      pending = true;
      input.disabled = true;
      confirm.disabled = true;
      onSubmit(value)
        .then(() => showForm(false))
        .catch((submitError) => {
          error.textContent = submitError.message;
          setHidden(error, false);
          announce(submitError.message, 'assertive');
        })
        .finally(() => {
          pending = false;
          input.disabled = false;
          confirm.disabled = input.value.trim() === '';
          if (!isHidden(form)) {
            input.focus();
          }
        });
    };

    onClick(toggle, () => showForm(true));
    onClick(confirm, submit);
    onClick(cancel, collapse);
    input.addEventListener('input', () => {
      confirm.disabled = pending || input.value.trim() === '';
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        submit();
      } else if (event.key === 'Escape') {
        // Collapse to the toggle, keep the popover itself open.
        event.preventDefault();
        event.stopPropagation();
        collapse();
      }
    });

    return { el: wrap };
  };
})(Drupal);
